/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  RevokeAPIKeyForUserOptions,
  RevokeAPIKeyForUserResponses,
} from '../types/RevokeAPIKeyForUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Revoke apikey for a user
 * {@link /v1/user/apikey/:key_id/revoke}
 */
export function revokeAPIKeyForUser<ThrowOnError extends boolean = true>(
  options: Options<RevokeAPIKeyForUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<RevokeAPIKeyForUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/user/apikey/{key_id}/revoke',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RevokeAPIKeyForUserResponses, ThrowOnError>>,
  )
}
